// extracted by mini-css-extract-plugin
export default {"wrapper":"MainWrapper_wrapper__MLzds","wrapper_main":"MainWrapper_wrapper_main__vfDH1"};